import { useEffect, useState } from 'react';
import { Bbo } from '../../../entities/drfq/bbo';
import { useDrfqMakerOrders } from '../drfq-maker-orderbook-context';
import { QuoteBuilderActions } from './form-context';

interface PrefillArgs {
  bbo: Bbo | null;
  actions: QuoteBuilderActions;
  didSubmit: boolean;
}
export function useQuoteBuilderPrefill({
  bbo,
  actions,
  didSubmit,
}: PrefillArgs) {
  const [isPrefilling, setIsPrefilling] = useState(true);
  const view = useDrfqMakerOrders();

  useEffect(() => {
    if (!isPrefilling || bbo == null || didSubmit) return;

    if (view.bid == null || view.ask == null) {
      setIsPrefilling(false);

      const hasFilledFromExistingHiddenLimitOrders =
        actions.fillPriceFromExistingHiddenLimitOrders();

      if (hasFilledFromExistingHiddenLimitOrders) {
        return;
      }

      // Fill price from previous input if any side is emplty
      const hasFilledFromPreviousInput = actions.fillPriceFromPreviousInput();

      // We only prefill screen prices if both sides are empty
      // and we haven't filled from a previous input.
      if (view.bid == null && view.ask == null && !hasFilledFromPreviousInput) {
        actions.fillPriceFromBbo();
      }
    }
  }, [actions, bbo, isPrefilling, view, didSubmit]);

  return isPrefilling;
}
